import * as React from 'react';
import { st, classes } from './ActionsMenuLayout.deprecated.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { ActionsMenuLayoutItem } from './Item/ActionsMenuLayoutItem';
import { ActionsMenuLayoutDivider } from './ActionsMenuLayoutDivider/ActionsMenuLayoutDivider';
import { KEYS } from '../../common/keyCodes';
import { ActionsMenuLayoutDataHooks, } from './types';
/** ActionsMenuLayout */
export class ActionsMenuLayout extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            focusedIdx: this.props.focusedIndex,
        };
        this.liRefs = {};
        this._onKeyDown = (event) => {
            if (event.key === KEYS.ArrowDown || event.key === KEYS.ArrowDownIE) {
                event.preventDefault(); // don't scroll page on key down
                this._focusItem(this._getNextItemIdx(1));
            }
            if (event.key === KEYS.ArrowUp || event.key === KEYS.ArrowUpIE) {
                event.preventDefault(); // don't scroll page on key down
                this._focusItem(this._getNextItemIdx(-1));
            }
        };
        this._onFocus = (event) => {
            const focusOnChild = !!Object.values(this.liRefs).find((i) => i.liRef?.current === event.target);
            // focus on initial list item after tab focusing
            if (!focusOnChild) {
                this._focusItem(0);
            }
        };
        // prevent firing focus after mouse click events
        this._preventFocus = (event) => event.preventDefault();
    }
    componentDidMount() {
        const { focusedIndex } = this.props;
        if (typeof focusedIndex !== 'undefined') {
            this._focusItem(focusedIndex);
        }
    }
    getDataAttributes(mobile) {
        return {
            [ActionsMenuLayoutDataHooks.mobile]: mobile,
        };
    }
    _getNextItemIdx(direction) {
        const nextItem = this.state.focusedIdx + direction;
        if (direction === 1) {
            return nextItem === Object.values(this.liRefs).length ? 0 : nextItem;
        }
        return nextItem < 0 ? Object.values(this.liRefs).length - 1 : nextItem;
    }
    _addRef(ref, index) {
        if (ref) {
            this.liRefs[index] = ref;
        }
    }
    _focusItem(idx) {
        this.setState({
            focusedIdx: idx,
        }, () => {
            Object.values(this.liRefs)[idx]?.liRef?.current.focus();
        });
    }
    render() {
        const { alignment, children, className } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement("ul", { onFocus: this._onFocus, onMouseDown: this._preventFocus, onKeyDown: this._onKeyDown, className: st(classes.root, { mobile }, className), ...this.getDataAttributes(mobile), "data-hook": this.props['data-hook'], role: "menu", "aria-labelledby": this.props['aria-labeledby'], "aria-label": this.props['aria-label'], tabIndex: 0 }, React.Children.map(children, (child, index) => child.type === ActionsMenuLayoutItem
            ? React.cloneElement(child, {
                className: classes.item,
                alignment,
                ref: (_ref) => {
                    this._addRef(_ref, index);
                },
            })
            : child)))));
    }
}
ActionsMenuLayout.Item = ActionsMenuLayoutItem;
ActionsMenuLayout.Divider = ActionsMenuLayoutDivider;
ActionsMenuLayout.displayName = 'ActionsMenuLayout';
//# sourceMappingURL=ActionsMenuLayout.js.map